import { Link } from 'react-router-dom';
import padlockImage from '@/assets/images/padlock-privacy.webp';
import { ArrowRight } from '@/components/icons';
import { Button } from '@/components/ui/button';
import { HeroSlideLayout } from './HeroSlideLayout';

const PRIVACY_ARTICLE_URL = '/help/privacy/como-protegemos-os-dados';

export const PrivacySlide = () => {
    return (
        <HeroSlideLayout
            title="Seus pacientes nunca chegam até a IA"
            description="Nome e dados são removidos antes de qualquer processamento. Sempre."
            action={
                <Link to={PRIVACY_ARTICLE_URL} className="block">
                    <Button size="lg" variant="outline" className="w-full sm:w-auto">
                        Como protegemos seus dados
                        <ArrowRight className="size-4" />
                    </Button>
                </Link>
            }
            // Centered rather than bottom-bled: the padlock is solid artwork and would
            // otherwise sit under the carousel dots.
            asideClassName="inset-y-0 right-6 items-center xl:right-10"
            aside={
                <img
                    src={padlockImage}
                    alt=""
                    // Intrinsic size, so the browser reserves the box instead of reflowing on load.
                    width={328}
                    height={152}
                    // The carousel keeps every slide mounted but translated off-viewport, so this
                    // defers the download until the user actually reaches this slide.
                    loading="lazy"
                    decoding="async"
                    // The artwork is wide (328x152); at lg the card is too narrow for the full
                    // size, so it steps down to clear the text column.
                    className="h-24 w-auto object-contain xl:h-36"
                />
            }
        />
    );
};
